import ExpandedLaborSummaryComponent from './ExpandedLaborSummary';

const ExpandedLaborSummary = ExpandedLaborSummaryComponent;

export default ExpandedLaborSummary;
